
function setRem() {
    const scale = document.documentElement.clientWidth / 750
    document.documentElement.style.fontSize = scale*100 + 'px'
}

setRem()
window.onresize = function () {
    setRem()
}


//////////////////
// WEBPACK FOOTER
// ./static/rem.js
// module id = TM+h
// module chunks = 1